<template>
  <div class="form-item__field form-item__field--full" :class="classes">
    <div class="input-group input-group-booking-detail input-height">
      <label class="input-label input-group-addon">{{ label }}</label>
      <div class="form-control input-height input-container">
        <div v-if="!editing">
          <p v-for="item in localField" :key="item">
            {{ item }}<span v-if="otherSelected && item === otherValue"> - {{ localOtherField }}</span>
          </p>
        </div>
        <div v-else class="checkbox checkbox-primary" v-for="(option, index) in options" :key="option.id">
          <input v-model="localField" type="checkbox" :id="`checkbox-${index}`" :value="option.id"/>
          <label :for="`checkbox-${index}`">{{ option.text }}</label>

          <input
            v-if="otherSelected && option.id === otherValue"
            v-model="localOtherField"
            name="other_text"
            type="text"
            class="form-control"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { BookingStateMapper as stateMapper } from 'pickstar-common'
export default {
  mixins: [stateMapper],

  props: {
    field: {
      required: true,
      type: String
    },
    value: {
      required: false
    },
    label: {
      required: true,
      type: String
    },
    fieldType: {
      required: false,
      default: 'text',
      type: String
    },
    rows: {
      required: false,
      default: 6,
      type: Number
    },
    options: {
      required: false,
      default: () => { return [] },
      type: Array
    },
    classes: {
      required: false,
      default: '',
      type: String
    },
    preText: {
      required: false,
      default: null,
      type: String
    },
    postText: {
      required: false,
      default: null,
      type: String
    },
    booking: {
      required: true,
      type: Object
    },
    propertyMutator: {
      required: true,
      type: Function
    },
    editable: {
      required: false,
      default: true
    },
    type: {
      required: false,
      default: ''
    },
    otherField: {
      required: false,
      default: null,
      type: String
    },
    otherValue: {
      required: false,
      default: null,
      type: String
    }
  },

  computed: {
    ...mapState('editing', ['editing']),

    localField: {
      get () {
        return this.booking[this.field]
      },
      set (value) {
        this.propertyMutator({
          property: this.field,
          value
        })
      }
    },

    localOtherField: {
      get () {
        if (this.otherField) {
          return this.booking[this.otherField]
        }
      },
      set (value) {
        if (this.otherField) {
          this.propertyMutator({
            property: this.otherField,
            value
          })
        }
      }
    },

    otherSelected () {
      return this.localField.findIndex(element => element === this.otherValue) !== -1
    }
  }
}
</script>

<style scoped lang="scss">
.input-container {
  display: flex;
  justify-content: space-between;
  align-items: center
}

.input-label {
  color: white !important;
  background-color: #1a1a1a !important;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap
}
</style>
